import * as Sentry from '@sentry/nextjs';

export function reportError(e: any, level: Sentry.SeverityLevel = 'error'): void {
   if (Sentry.isInitialized()) {
      const context = {
         level,
      };
      if (typeof e === 'string') {
         Sentry.captureMessage(e, context);
      } else {
         Sentry.captureException(e, context);
      }
   } else {
      console.error(e);
   }
}
